






















import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import KintaiCardWeekday from '@/components/kintai/molecules/KintaiCardWeekday.vue'
import KintaiCardHoliday from '@/components/kintai/molecules/KintaiCardHoliday.vue'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import { TcwAPIDate } from '@/tcw/domain/types'

@Component({
  components: { KintaiCardWeekday, KintaiCardHoliday }
})
export default class KintaiCardList extends Mixins(BaseComponent) {
  @Prop({ type: Boolean, default: false })
  private editable!: boolean
  @Prop({ default: () => [] })
  private kintaiList!: ApiGeneralObjectArrayPayload

  @Emit()
  private clickDayChienShoumei(_targetDate: TcwAPIDate): void {
    /** */
  }

  private isMoveTodayAfterInit = true

  private isWorkday(dayData: ApiGeneralSinglePayload): boolean {
    return !this.isHoliday(dayData)
  }
  private isHoliday(dayData: ApiGeneralSinglePayload): boolean {
    if (dayData?.kintai instanceof Object) {
      const code = (dayData.kintai as { kyujitsuCode: string }).kyujitsuCode as string
      return this.tcw.isHoliday(code)
    } else {
      return false
    }
  }

  protected mounted(): void {
    //データ表示後に今日日付へ移動する
    if (this.isMoveTodayAfterInit) {
      const todayCard = document.getElementsByClassName('is-today')
      const todayCardElem = todayCard.item(0)
      if (todayCardElem) {
        todayCardElem.scrollIntoView(true)
      }
    }
  }

  private openEdit(targetDate: Date) {
    this.$tcw.$store.basic.setTargetDate(targetDate)
    this.$router.push('/kintai/input')
  }
}
